import apiClient from './client';
import type { Session, CreateSessionRequest, CreateSessionResponse, PracticeSelection, RatingSummary } from '@/types/session';

export async function setPracticeSelection(id: string, selection: PracticeSelection): Promise<Session> {
  return (await apiClient.put<Session>(`/sessions/${id}/practice`, selection)).data;
}
export async function getSessionRating(id: string): Promise<RatingSummary> {
  return (await apiClient.get<RatingSummary>(`/sessions/${id}/rating`)).data;
}
export async function rateSession(id: string, score: number): Promise<RatingSummary> {
  return (await apiClient.put<RatingSummary>(`/sessions/${id}/rating`, { score })).data;
}

/**
 * 获取所有会话列表。
 */
export async function getSessions(scope: 'own' | 'all' = 'own'): Promise<Session[]> {
  const response = await apiClient.get<Session[]>('/sessions', { params: { scope } });
  return response.data as unknown as Session[];
}

/**
 * 创建新会话。
 * @param data 可选标题
 */
export async function createSession(data?: CreateSessionRequest): Promise<CreateSessionResponse> {
  const response = await apiClient.post<CreateSessionResponse>('/sessions', data || {});
  return response.data as unknown as CreateSessionResponse;
}

/**
 * 获取单个会话详情。
 * @param id 会话 ID
 */
export async function getSession(id: string): Promise<Session> {
  const response = await apiClient.get<Session>(`/sessions/${id}`);
  return response.data as unknown as Session;
}

/**
 * 删除会话。
 * @param id 会话 ID
 */
export async function deleteSession(id: string): Promise<void> {
  await apiClient.delete(`/sessions/${id}`);
}

export interface SessionFilters {
  scope: 'own' | 'all';
  limit: number;
  offset: number;
  q?: string;
  created_from?: string;
  created_before?: string;
}

export async function searchSessions(params: SessionFilters, signal?: AbortSignal): Promise<Session[]> {
  return (await apiClient.get<Session[]>('/sessions', { params, signal })).data;
}

export async function exportSession(id: string, format: 'md' | 'txt' | 'json', side: 'all' | 'left' | 'right') {
  return (await apiClient.get<{ filename: string; content: string }>(`/sessions/${id}/export`, {
    params: { format, side },
  })).data;
}
